import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import ModalDropdown from '../../component/ModalDropdown';
import { Icons, Images } from '../../assets';

const SuccessModal = (props) => {
    const { isOpen = false, closePopUp, successText = 'Success', modalText, timeOutModal = true, boxAlign = null } = props

    return (
        <>
            <ModalDropdown isOpen={isOpen} closePopUp={closePopUp} timeOutModal={timeOutModal} boxAlign={boxAlign}>
                <div className={`${classes.successModalWrapper} flex items-center `}>
                    <div className={`${classes.successIcon} flex items-center justify-center`}>
                        <img src={Images.successGif} alt='Success' />
                    </div>
                    <div className={`${classes.successModalText}`}>{successText}</div>
                    {modalText ?
                        <div className={`${classes.modalDescription}`}>{modalText}</div>
                        : null
                    }
                </div>
            </ModalDropdown>
        </>
    );
}

export default SuccessModal